module.exports = ".float {\n  width: 150px; }\n\n.contentBottom {\n  margin-top: 35px;\n  height: 100%;\n  min-height: 70vh; }\n\n.entrylistASN {\n  height: 85%;\n  max-height: 500px;\n  width: 100%;\n  overflow-y: scroll; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/status-uploadedInvoices/estatus-cargaFacturas.component.scss
// module id = ./src/app/pages/status-uploadedInvoices/estatus-cargaFacturas.component.scss
// module chunks = main